<template>
  <nav v-if="isWebView || !headerBack || useLinkageAppAndNecFlag" class="drawer" :class="{ 'is-open': drawerShow }">
    <div class="drawer-user">
      <table v-if="isLoggedIn" class="drawer-user-table">
        <tr>
          <th>NAME</th>
          <td>{{ fullname }}</td>
        </tr>
        <tr>
          <th>USER ID</th>
          <td>{{ infor?.number }}</td>
        </tr>
      </table>
    </div>
    <div class="drawer-menu">
      <div v-for="(item, index) in menuData" :key="index" class="drawer-menu-item">
        <p class="drawer-menu-title">{{ item.group }}</p>
        <ul class="drawer-nav">
          <template v-if="item.checkLogin">
            <template v-for="(child, childIndex) in isLoggedIn ? item.children.withAuth : item.children.withoutAuth">
              <a v-if="child.href" class="drawer-nav-link" :href="child.href" :key="childIndex">{{ child.label }}</a>
              <li
                v-else-if="!child.isNotShown"
                :key="`${childIndex}-${child.label}`"
                class="drawer-nav-item"
                @click="$emit('handle-click-menu', child)"
              >
                <router-link :to="{ name: child.isButtonMenu ? '' : child.router, query: child.query ? { directory: child.query } : {} }" class="drawer-nav-link">{{ child.label }}</router-link>
              </li>
            </template>
          </template>
          <template v-else>
            <template v-for="(child, childIndex) in item.children">
              <li class="drawer-nav-item" :key="childIndex" @click="$emit('handle-click-menu', child)" v-if="child.href || !child.isNotShown">
                <a v-if="child.href" class="drawer-nav-link" :href="child.href" target="_blank">{{ child.label }}</a>
                <button v-else-if="child.isButtonPayment && !child.isNotShown" class="drawer-nav-link" tag="button" :disabled="child.disabled" @click="redirectToPay">{{ child.label }}</button>
                <router-link v-else-if="!child.isNotShown" :to="{ name: child.router }" v-slot="{ navigate }">
                  <button class="drawer-nav-link" :disabled="child.disabled" @click="navigate">{{ child.label }}</button>
                </router-link>
              </li>
            </template>
          </template>
        </ul>
      </div>
    </div>
    <template v-if="!(useLinkageAppAndNecFlag && nativeType)">
      <button v-if="isLoggedIn" class="drawer-logout" type="button" @click="logout">
        ログアウトする
      </button>
      <router-link v-else :to="{ name: isLoginOnlyPhone ? 'LoginSms' : 'Login' }" class="drawer-logout">
        ログインする
      </router-link>
    </template>
  </nav>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { EventConstants } from '@/config/constant';

const store = useStore();
const route = useRoute();
const router = useRouter();

const { headerBack, drawerShow, logout } = defineProps({
  headerBack: Boolean,
  drawerShow: Boolean,
  logout: Function,
});

defineEmits(['handle-click-menu']);

const infor = computed(() => store.getters['auth/infor']);
const isLoggedIn = computed(() => store.getters['auth/token']);
const isChargeableDate = computed(() => store.getters['event/isChargeableDate']);
const isPaymentEventType = computed(() => store.getters['event/isPaymentEventType']);
const eventInfo = computed(() => store.getters['event/childEventInfo']);
const isWebView = computed(() => store.getters['common/isWebView']);
const isPaymentableDate = computed(() => store.getters['event/isPaymentableDate']);
const parentEventInfo = computed(() => store.getters['event/parentEventInfo']);
const hasHistoryPoint = computed(() => store.getters['event/hasHistoryPoint']);
const hasHistoryCurrency = computed(() => store.getters['event/hasHistoryCurrency']);
const isDisplayShopMenuFront = computed(() => store.getters['event/isDisplayShopMenuFront']);
const isChildEventUseTicketFlag = computed(() => store.getters['event/isChildEventUseTicketFlag']);
const isUseTickFlag = computed(() => store.getters['event/isUseTicketFlag']);
const useLinkageAppAndNecFlag = computed(() => store.getters['event/useLinkageAppAndNecFlag']);
const useLinkageAppAndNotLoggedIn = computed(() => store.getters['event/useLinkageAppAndNotLoggedIn']);
const isLinkageView = computed(() => store.getters['common/isLinkageView']);
const usePosFlag = computed(() => store.getters['event/usePosFlag']);
const isCustomerTesting = computed(() => store.getters['auth/isCustomerTesting']);
const isUsePoint = computed(() => store.getters['auth/isUsePoint']);
const nativeType = computed(() => store.getters['event/nativeType']);
const appType = computed(() => store.getters['event/appType']);
const registrationUrlOtherApp = computed(() => store.getters['event/registrationUrlOtherApp']);

const fullname = computed(() => `${infor.value?.nameSei || ''} ${infor.value?.nameMei || ''}`);
const hasCoupon = computed(() => parentEventInfo.value?.hasCoupon);
const pausedEvent = computed(() => eventInfo.value?.status?.id === EventConstants.status.paused.value);
const isEntrySms = computed(() => parentEventInfo.value?.isLoginPhone || isLoginOnlyPhone.value);
const isLoginOnlyPhone = computed(() => parentEventInfo.value?.isLoginOnlyPhone);
const isChargePaymentShown = computed(() => useLinkageAppAndNotLoggedIn.value && nativeType.value);
const menuData = computed(() => [
  {
    group: 'メニュー',
    children: [
      { label: 'HOME', router: 'Home' },
      { label: 'イベント一覧', router: 'EventList' },
      { label: 'お店を探す', router: 'Search' },
      { label: 'クーポン一覧', router: 'SearchCoupon', isNotShown: !hasCoupon.value && !isDisplayShopMenuFront.value },
      { label: 'お支払い', isButtonPayment: true, disabled: (!isPaymentableDate.value && (!eventInfo.value?.isPreparePayment || !isCustomerTesting.value)) || pausedEvent.value, isNotShown: isChargePaymentShown.value },
      { label: isUseTickFlag.value && isChildEventUseTicketFlag.value ? 'TICKETを購入する' : 'チャージする', router: 'Charge', disabled: (!isChargeableDate.value && (!eventInfo.value?.isPrepareCharge || !isCustomerTesting.value)) || pausedEvent.value, isNotShown: isChargePaymentShown.value || isPaymentEventType.value },
      { label: 'お知らせ', router: 'NewsOfficial' },
    ]
  },
  {
    group: 'マイメニュー',
    checkLogin: true,
    children: {
      withAuth: [
        { label: 'お気に入り', router: 'FavoriteShop', query: route.params?.directory },
        { label: 'マイページ', router: 'Mypage' },
        { label: 'ご利用履歴', router: 'HistoryAll', isNotShown: eventInfo.value?.newUIPointFlag && !hasHistoryCurrency.value },
        { label: 'ポイント履歴', router: 'PointHistoryAll', isNotShown: !(eventInfo.value?.newUIPointFlag && hasHistoryPoint.value && isUsePoint.value) },
        { label: 'ポイント用QR読み取り', isButtonQR: true, isNotShown: !(eventInfo.value?.newUIPointFlag && isUsePoint.value) },
      ],
      withoutAuth: [
        parentEventInfo.value?.useLinkageNecFlag && appType.value && registrationUrlOtherApp.value ?
          { label: '新規会員登録', href: registrationUrlOtherApp.value } :
          { label: '新規会員登録', router: eventInfo.value?.useAuthentication ? 'Authentication' : isEntrySms.value ? 'EntrySms' : 'Entry' }
        ,
        { label: 'ログイン', router: isLoginOnlyPhone.value ? 'LoginSms' : 'Login' },
      ],
    },
  },
  {
    group: 'INFO',
    children: [
      { label: '利用規約', href: eventInfo.value?.termsUrl },
      { label: 'プライバシーポリシー', href: eventInfo.value?.privacyPolicyUrl },
      { label: eventInfo.value?.titleAdditionalUrl, href: eventInfo.value?.additionalUrl, isNotShown: !eventInfo.value?.titleAdditionalUrl },
      { label: isLinkageView.value ? null : 'お問い合わせ', router: 'ContactChild', isNotShown: (!eventInfo.value?.useContactFrontFlag || (isLinkageView.value && nativeType.value)) },
      // { label: 'ヘルプ', href: '' },
    ],
  },
].filter(element => !(useLinkageAppAndNecFlag.value && nativeType.value) || (isLoggedIn.value || !element.checkLogin)));

const redirectToPay = async() => {
  await store.dispatch('event/getChildEventInfo', { isHome: 1 });
  router.push({ name: usePosFlag.value ? 'PayBarcode' : 'Pay' });
};
</script>
